import { SyncIndicator } from '@/features/sync-status/components/sync-indicator';
import { useTranslation } from '@/shared/i18n/use-translation';
import { BrandMark } from './brand-mark';
import { useCrumbs } from './use-crumbs';

/** Phones: the brand mark (home), the current section and the sync state, in one short bar. */
export function MobileHeader() {
  const { t } = useTranslation();
  const crumbs = useCrumbs();
  const title = crumbs.map((crumb) => t(crumb.label)).join(' · ');
  return (
    <header className="sticky top-0 z-30 flex items-center gap-3 border-b bg-background/85 px-4 pt-[env(safe-area-inset-top)] backdrop-blur-md md:hidden">
      <div className="flex h-13 min-w-0 flex-1 items-center gap-3">
        <BrandMark />
        <span className="truncate font-semibold">{title}</span>
      </div>
      <SyncIndicator showLabel={false} />
    </header>
  );
}
